import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";

import EditWebhookEndpoint, { allowedEventTypes } from "./EditWebhookEndpoint";

import { ApiKeysQuery } from "~/graphql/__generated__/graphql";

type Props = {
  apiKeys: ApiKeysQuery["apiKey"];
  webhookEndpoints: ApiKeysQuery["webhookEndpoint"];
}
type Endpoint = ApiKeysQuery["webhookEndpoint"][number];

const WebhookEndpoints = ({ apiKeys, webhookEndpoints }: Props) => {
  const [editEndpoint, setEditEndpoint] = useState<Partial<Endpoint> | null>(null);

  // If there's already an endpoint every event type, don't display the popup for adding a new one
  const canAddNewEndpoint = !allowedEventTypes.every(eventType => webhookEndpoints.find(e => e.eventType === eventType));

  return <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Event Type</TableCell>
          <TableCell>URL</TableCell>
          <TableCell>API Key</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {webhookEndpoints.map((endpoint) => (
          <TableRow key={endpoint.id}>
            <TableCell>
              {endpoint.eventType}
              <IconButton
                size="small"
                onClick={() => {
                  setEditEndpoint({...endpoint});
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </TableCell>
            <TableCell>
              {endpoint.url}
            </TableCell>
            <TableCell>
              {apiKeys.find(key => key.id === endpoint.apiKeyId)?.apiKey}
            </TableCell>
          </TableRow>
        ))}

        {canAddNewEndpoint && <TableRow>
          <TableCell colSpan={2}>
            <Button
              onClick={() => setEditEndpoint({} as Partial<Endpoint>)}
              size="small"
              startIcon={<AddCircleOutlineIcon fontSize="small" />}
            >
              Add New Endpoint
            </Button>
          </TableCell>
        </TableRow>}
      </TableBody>
    </Table>
    {editEndpoint && <EditWebhookEndpoint
      endpoint={editEndpoint}
      onClose={() => setEditEndpoint(null)}
      apiKeys={apiKeys}
      existingEndpoints={webhookEndpoints}
    />}
  </TableContainer>
}

export default WebhookEndpoints;
